
const ExperiencesData = [
    {
        title: "Devtown - Full Stack Developer(Intern)",
    },
    {
        title: "Acmegrade - Web Developer(Intern)",
    },
]
export default ExperiencesData;